// City Hustle's own code (its rule set, the Lagos city map and its routes) is loaded only when a
// shift is near: a phone that never hustles never carries it. Loading it registers the hustle rules
// and the city with the simulation and the maps.
type Hustle = typeof import('@wahala/simulation/hustle');

let kit: Hustle | null = null;
let loading: Promise<Hustle> | null = null;

/** The hustle module once loaded, or null before. */
export const hustleKit = (): Hustle | null => kit;

/** Load the hustle module (once). */
export function loadHustle(): Promise<Hustle> {
  loading ??= import('@wahala/simulation/hustle').then((m) => {
    kit = m;
    return m;
  });
  return loading;
}
